import apiClient from "../api/apiClient";
import { endPoints } from "../config/endpoints";

export const customerService = {
  async getDropdownAsync() {
    const response = await apiClient.get(endPoints.customer.dropdown);
    return response.data;
  },

  async getAllAsync(params) {
    const response = await apiClient.get(endPoints.customer.getAll, {
      params: params,
    });

    return response.data;
  },

  async getAllSearchAsync(params, signal) {
    const response = await apiClient.get(endPoints.customer.getAllSearch, {
      params: params,
      signal: signal,
    });

    return response.data;
  },

  async create(data) {
    const response = await apiClient.post(
      endPoints.customer.create,
      data
    );
    return response.data;
  },

  async update(id, data) {
    const response = await apiClient.post(
      `${endPoints.customer.update}/${id}`,
      data
    );
    return response.data;
  },

  async toggleActivate(id) {
    const response = await apiClient.patch(
      `${endPoints.customer.toggleActivate}/${id}`
    );
    return response.data;
  },

  async edit(id) {
    const response = await apiClient.get(
      `${endPoints.customer.edit}/${id}`
    );
    return response.data;
  },

  async getDetail(id) {
    const response = await apiClient.get(
      `${endPoints.customer.getDetail}/${id}`
    );
    return response.data;
  },

  async delete(id) {
  const response = await apiClient.delete(
    `${endPoints.customer.delete}/${id}`
  );
  return response.data;
},

  async deleteImageAsync(id) {
    const response = await apiClient.delete(
      `${endPoints.customer.deleteImage}/${id}`
    );
    return response.data;
  },
};